import React from 'react';
import {
  Wrapper,
  HeaderLabel,
  Content,
  IconWrapper,
  GridRow,
  Cell,
} from './AllocationGroup.styles';
import { IAllocationListItem, IAllocation } from '../types';
import { AllocationRow } from '../AllocationRow';
import { ApIcon, colors } from '@alixpartners/ui-components';
import isBoolean from 'lodash/isBoolean';

interface IProps {
  name: string;
  data: IAllocationListItem[];
  onChange(application: IAllocation): void;
  isExpandedProp?: boolean;
  isInvalid?: boolean;
  search?: string;
}

interface IState {
  isExpanded: boolean;
}

export class AllocationGroup extends React.Component<IProps, IState> {
  state = {
    isExpanded: isBoolean(this.props.isExpandedProp)
      ? this.props.isExpandedProp
      : true,
  };

  componentDidUpdate(prevProps: IProps) {
    const { isExpandedProp } = this.props;

    if (
      isBoolean(isExpandedProp) &&
      isExpandedProp !== prevProps.isExpandedProp
    ) {
      this.setState({ isExpanded: isExpandedProp });
    }
  }

  toggleGroup = () => {
    const { isExpanded } = this.state;

    this.setState({ isExpanded: !isExpanded });
  };

  render() {
    const { data, name, isInvalid, search, onChange } = this.props;
    const { isExpanded } = this.state;

    return (
      <Wrapper>
        <GridRow>
          <Cell>
            <IconWrapper isExpanded={isExpanded} onClick={this.toggleGroup}>
              <ApIcon
                iconName="baseline_keyboard_arrow_right"
                iconColor={colors.grey5}
                iconSize={16}
              />
            </IconWrapper>
            <HeaderLabel title={name}>{name}</HeaderLabel>
          </Cell>
        </GridRow>

        {isExpanded && (
          <Content>
            {data.map((item) => (
              <AllocationRow
                key={item.id}
                data={item}
                isInvalid={isInvalid}
                search={search}
                onChange={onChange}
              />
            ))}
          </Content>
        )}
      </Wrapper>
    );
  }
}
